import { render, staticRenderFns } from "./StatsLiveScreen.vue?vue&type=template&id=b4862784&scoped=true&"
import script from "./StatsLiveScreen.vue?vue&type=script&lang=js&"
export * from "./StatsLiveScreen.vue?vue&type=script&lang=js&"
import style0 from "./StatsLiveScreen.vue?vue&type=style&index=0&id=b4862784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4862784",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VSubheader})
